import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import checkIfLinkIsCurrent from "@components/WebsiteRevamp/utils/checkIfLinkIsCurrent"
import {getLink} from "@hooks/PagesData/getLink"
import {MenuModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import Link from "next/link"
import {useRouter} from "next/router"
import React from "react"
import {ReactSVG} from "react-svg"

import Badge from "./FreeBadge"
import styles from "./SubheaderInsed.module.scss"

type Props = {
	data: MenuModuleType[]
}

const ProductsSubheaderInside = (props: Props) => {
	const items = props.data

	const router = useRouter()

	return (
		<>
			<ContainerWrapper className={styles.subheaderBox}>
				{items.map((item, index) => {
					const {current, parent} = checkIfLinkIsCurrent(
						router.asPath,
						item.link,
						item.subLinksSelect,
					)
					const active = current || parent ? styles.active : ""

					return (
						<React.Fragment key={`product-subheader-${index}`}>
							<Link
								className={`${styles.linkBox}  ${active} ${styles.ItemBox}`}
								href={item?.link ?? ""}
							>
								{item?.menuLinkIconSvg && (
									<ReactSVG
										className={styles.logo}
										src={item.menuLinkIconSvg?.src ?? ""}
									/>
									// <div className={styles.logo}>
									// 	<Image
									// 		{...item.menuLinkIconSvg}
									// 		className={styles.LogoImage}
									// 	/>
									// </div>
								)}
								<div
									style={{
										display: "flex",
										justifyContent: "start",
										alignItems: "center",
										width: "100%",
										gap: "0.5rem",
									}}
								>
									<Typography
										as={"p"}
										content={item.subtitle}
										size={Size.XXS}
										variant={Variant.Description}
										contrast={index !== 0}
										style={
											index === 0
												? {
														color: "#175eeb",
												  }
												: {}
										}
										noPadding
									/>
									{index === 0 && <Badge label={"FREE"} />}
									{index === 1 && (
										<Badge label={"FREE TRIAL"} />
									)}
									{/* {index === 2 && (
										<div
											style={{
												opacity: 0,
											}}>
											<Badge label={"STUDIO"} />
										</div>
									)} */}
								</div>
							</Link>
						</React.Fragment>
					)
				})}

				<Link
					className={`${styles.linkBox} ${styles.ItemBox}  ${styles.ContactSales}`}
					href={getLink("bookADemo")}
				>
					<Typography
						as={"p"}
						content={"Need help? Contact sales"}
						size={Size.S}
						variant={Variant.Title}
						className={styles.ContactSalesTitle}
						noPadding
					/>
				</Link>
			</ContainerWrapper>
		</>
	)
}

export default ProductsSubheaderInside
